/**
 * @param {string|number} ssn
 * @returns {{month: number, year: number, day: number}|undefined}
 */
function getBirthdateFromSsn (ssn) {
  if (!ssn) return

  // Trim value
  const val = ssn
    .toString()
    .trim()

  // Get century from century sign
  let century = ''
  switch (val.charAt(6)) {
    case '+':
      century = '18'
      break
    case '-':
      century = '19'
      break
    case 'A':
      century = '20'
      break
    default:
      return
  }

  const year = century + val.substr(4, 2)
  const month = val.substr(2, 2)
  const day = val.substr(0, 2)

  return {
    day: parseInt(day, 10),
    month: parseInt(month, 10),
    year: parseInt(year, 10)
  }
}

module.exports = { getBirthdateFromSsn }
